import { compose } from 'recompose';
import { themr } from '@friendsofreactjs/react-css-themr';

import ModalButtonsComponent from './ModalButtons';
import intlEquipped from '../../../hocs/intlEquipped';

const ModalButtons = compose(
    themr('ModalButtons'),
    intlEquipped
)(ModalButtonsComponent);

export default ModalButtons;
